import { render, staticRenderFns } from "./ReviewsSettings.vue?vue&type=template&id=6ade5ec4&"
import script from "./ReviewsSettings.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports